export const dayanDetailType = Object.freeze({
  // 作业列表
  rebuildRunning: 'rebuildRunning',
  rebuildEnd: 'rebuildEnd',
  // 帧详情
  sky3RunningDetail: 'sky3RunningDetail',
  sky3EndDetail: 'sky3EndDetail',
  productEndDetail: 'productEndDetail',
  productRunningDetail: 'productRunningDetail',
  rebuildEndDetail: 'rebuildEndDetail',
  rebuildRunningDetail: 'rebuildRunningDetail',
  // 日志
  sky3RunningLog: 'sky3RunningLogDetails',
  sky3EndLog: 'sky3EndLogDetails',
  rebuildRunningLog: 'rebuildRunningLogDetails',
  rebuildEndLog: 'rebuildEndLogDetails',
  productRunningLog: 'productRunningLogDetails',
  productEndLog: 'productEndLogDetails',
  // 配置文档
  sky3RunningConfigDetails: 'sky3RunningConfigDetails',
  sky3EndConfigDetails: 'sky3EndConfigDetails',
  productRunningConfigDetails: 'productRunningConfigDetails',
  productEndConfigDetails: 'productEndConfigDetails',
  rebuildRunningConfigDetails: 'rebuildRunningConfigDetails',
  rebuildEndConfigDetails: 'rebuildEndConfigDetails',
})

export const sky3DetailList = [
  dayanDetailType.sky3RunningDetail,
  dayanDetailType.sky3EndDetail,
]

export const productDetailList = [
  dayanDetailType.productRunningDetail,
  dayanDetailType.productEndDetail,
]

export const rebuildDetailList = [
  dayanDetailType.rebuildRunningDetail,
  dayanDetailType.rebuildEndDetail,
]
